import React, { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import CustomTable from "../../../components/table/table";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import {
  admin_internship_applications_list,
  superadmin_internship_applications_list,
} from "../admin.api";
import moment from "moment";
import "./style.css";
import { FiEye } from "react-icons/fi";

const getStatusInfo = (status) => {
  const statusMap = {
    0: {
      label: "Pending",
      class: "pending",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
      ),
    },
    1: {
      label: "Approved",
      class: "successs",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      ),
    },
    2: {
      label: "Reverted to User",
      class: "danger",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M12 8v4m0 4h.01"></path>
        </svg>
      ),
    },
    3: {
      label: "Rejected",
      class: "danger",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
      ),
    },
    4: {
      label: "Submitted for Acceptance",
      class: "info",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
      ),
    },
    5: {
      label: "Reverted to Admin",
      class: "pending",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M12 8v4m0 4h.01"></path>
        </svg>
      ),
    },
  };
  const defaultIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
  );
  return (
    statusMap[status] || {
      label: "Pending",
      class: "pending",
      icon: defaultIcon,
    }
  );
};

const getRankingStatusInfo = (status) => {
  const statusMap = {
    open: {
      label: "Open",
      class: "info",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M12 8v4m0 4h.01"></path>
        </svg>
      ),
    },
    ranking_confirmed: {
      label: "Ranking Confirmed",
      class: "successs",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      ),
    },
    closed: {
      label: "Closed",
      class: "secondary",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
      ),
    },
  };
  const defaultIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="16" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </svg>
  );

  return (
    statusMap[status] || {
      label: status
        ? status
          .split("_")
          .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
          .join(" ")
        : "--",
      class: "secondary",
      icon: defaultIcon,
    }
  );
};

const getAdminType = (props) => {
  try {
    const token = props?.state?.payload || sessionStorage.getItem("token") || localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode(token);
      if (decoded && decoded.user_type !== undefined) {
        return Number(decoded.user_type);
      }
    }
  } catch (e) {
    console.error("Error decoding token:", e);
  }
  return Number(localStorage.getItem("adminType")) || 0;
};

export default function InternshipApplications(props) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    status: "",
  });

  useEffect(() => {
    fetchApplications();
  }, [page, perPage, filters]);

  const handlePerPageChange = (e) => {
    setPerPage(parseInt(e.target.value));
    setPage(1);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value === "all" ? "" : value });
    setPage(1);
  };

  const fetchApplications = () => {
    setIsLoading(true);
    const adminType = getAdminType(props);
    const adjustedPerPage = perPage === "all" ? "all" : perPage; // Pass 'all' directly to the API

    const apiCall =
      adminType === 2
        ? superadmin_internship_applications_list(page, adjustedPerPage, filters)
        : admin_internship_applications_list(page, adjustedPerPage, filters);

    apiCall
      .then((res) => {
        if (res?.success) {
          let tdata = res.data || [];
          tdata.forEach((item, index) => {
            item["slno"] = (page - 1) * (perPage === "all" ? 1 : adjustedPerPage) + index + 1;
          });
          setData(tdata);
          setTotalPages(perPage === "all" ? 1 : res.pagination?.last_page || 1); // Disable pagination for 'all'
        } else {
          setSnackMessage("Failed to load internship applications");
          setIsSnackError(true);
          setSnackOpen(true);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching applications:", error);
        setSnackMessage("Error loading internship applications");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsLoading(false);
      });
  };

  const snackbarClose = () => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };

  const columns = [
    // { title: "ID", field: "id" },
    { title: "Reference ID", field: "reference_id" },
    { title: "Full Name", field: "full_name" },
    { title: "Email", field: "email" },
    { title: "Phone", field: "phone_no" },
    {
      title: "Educational Qualification Status",
      field: "course_completion_status",
      render: (rowData) => (
        <span className="text-capitalize">
          {rowData.course_completion_status}
        </span>
      ),
    },
    {
      title: "Date Applied",
      field: "created_at",
      render: (rowData) => moment(rowData.created_at).format("DD-MM-YYYY"),
    },
    {
      title: "Student Application Status",
      field: "status",
      render: (rowData) => {
        const statusInfo = getStatusInfo(rowData.status);
        return (
          <span className={`status-badge ${statusInfo.class}`}>
            <span className="status-icon">{statusInfo.icon}</span>
            <span className="status-label">{statusInfo.label}</span>
          </span>
        );
      },
    },
    {
      title: "Company Allotment Status",
      field: "ranking_status",
      render: (rowData) => {
        if (rowData.status !== 1) {
          return "--";
        }
        const statusInfo = getRankingStatusInfo(rowData.ranking_status || "open");
        return (
          <span className={`status-badge ${statusInfo.class}`}>
            <span className="status-icon">{statusInfo.icon}</span>
            <span className="status-label">{statusInfo.label}</span>
          </span>
        );
      },
    },
    {
      title: "Action",
      render: (rowData) => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-sm btn-outline-primary action-btn"
            onClick={() =>
              props.history.push(`/admin-internship-applications/${rowData.id}`)
            }
            title="View"
          >
            <FiEye size={16} />
          </button>
        </div>
      ),
    },
  ];

  const renderPagination = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    if (start > 1) {
      pages.push(
        <button
          key={1}
          className="btn btn-sm btn-outline-primary"
          onClick={() => setPage(1)}
        >
          1
        </button>,
      );
      if (start > 2)
        pages.push(
          <span key="start-dots" className="px-1 text-primary">
            ...
          </span>,
        );
    }

    for (let i = start; i <= end; i++) {
      pages.push(
        <button
          key={i}
          className={`btn btn-sm ${page === i ? "btn-primary text-white" : "btn-outline-primary"}`}
          onClick={() => setPage(i)}
        >
          {i}
        </button>,
      );
    }

    if (end < totalPages) {
      if (end < totalPages - 1)
        pages.push(
          <span key="end-dots" className="px-1 text-primary">
            ...
          </span>,
        );
      pages.push(
        <button
          key={totalPages}
          className="btn btn-sm btn-outline-primary"
          onClick={() => setPage(totalPages)}
        >
          {totalPages}
        </button>,
      );
    }

    return pages;
  };

  return (
    <div className="container-fluid mt-4">
      <Loader open={isLoading} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />

      <div className="card shadow-sm">
        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            <b>Internship Applications : Students</b>
          </h5>
          <button
            className={`filter-icon-btn ${showFilters ? "active" : ""}`}
            onClick={() => setShowFilters(!showFilters)}
            title="Toggle Filters"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
            </svg>
          </button>
        </div>
        <div className="card-body pt-0">
          <div className={`filter-container ${showFilters ? "show" : ""}`}>
            <div className="row align-items-end">
              <div className="col-md-3">
                <label className="form-label small">Student Application Status</label>
                <select
                  name="status"
                  className="form-control filter-select"
                  value={filters.status}
                  onChange={handleFilterChange}
                >
                  <option value="">All Statuses</option>
                  <option value="0">Pending</option>
                  <option value="4">Submitted for Acceptance</option>
                  <option value="1">Approved</option>
                  <option value="5">Reverted to Admin</option>
                  <option value="2">Reverted to User</option>
                </select>
              </div>
              <div className="col-md-2 d-flex gap-2">
                <button
                  className="filter-action-btn"
                  title="Reset Filters"
                  onClick={() => {
                    setFilters({ status: "" });
                    setPage(1);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                    <path d="M3 3v5h5"></path>
                  </svg>
                </button>
                <button
                  className="filter-action-btn close-btn"
                  title="Close Filters"
                  onClick={() => setShowFilters(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <CustomTable
            columns={columns}
            data={data}
            paging={false}
            options={{
              search: true,
              selection: false,
              exportButton: false,
            }}
          />

          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="flex-grow-1"></div>
            <div className="btn-group">
              <button
                className="btn btn-sm btn-outline-primary"
                disabled={page === 1}
                onClick={() => setPage((p) => p - 1)}
              >
                Prev
              </button>
              {renderPagination()}
              <button
                className="btn btn-sm btn-outline-primary"
                disabled={page === totalPages}
                onClick={() => setPage((p) => p + 1)}
              >
                Next
              </button>
            </div>
            <div className="flex-grow-1 d-flex justify-content-end">
              <select
                className="form-control form-control-sm w-auto ml-2"
                value={perPage}
                onChange={handlePerPageChange}
                style={{ fontSize: "8px", height: "31px" }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="all">All</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
